export const squareColors: { [key: number]: string } = {
  "-1": "transparent",
  0: "#000000",
  1: "#66CCFF",
  2: "#FFD500",
  3: "#FF971C",
  4: "#0341AE",
  5: "#72CB3B",
  6: "#FF3213",
  7: "#AA00FF",
  9: "#808080",
};

export enum appColors {
  black = "#121212EE",
  white = "#eee",
  primary = "#3b5998",
  primaryLight = "#4c669f",
  primaryDark = "#192f6a",
  secondary = "orange",
  error = "#B00020",
}
